<template>
    <section class="recipe-products">
        <div class="heading-container">
            <h2
                class="h5"
                v-test:heading
            >
                products
            </h2>
        </div>

        <div class="products-container">
            <div class="products-carousel">
                <base-carousel
                    navigation
                    :breakpoints="breakpoints"
                    :space-between="10"
                >
                    <div
                        v-for="product in products"
                        :key="product.name"
                        :slot="`slot_${ product.name }`"
                        class="product"
                    >
                        <mini-product-card
                            :name="product.name"
                            :image="product.image"
                            :calories="product.calories"
                            :to="product.to"
                        />
                    </div>
                </base-carousel>
            </div>

            <div
                v-if="makeMeVeggieUrl"
                class="link-container"
            >
                <nuxt-link
                    :to="makeMeVeggieUrl"
                    class="link"
                    v-test:veggieLink
                >
                    make me veggie!
                </nuxt-link>
            </div>
        </div>
    </section>
</template>

<script>
    import MiniProductCard from '../MiniProductCard/MiniProductCard';
    import BaseCarousel from '../BaseCarousel/BaseCarousel';

    export default {
        name: 'recipe-products',

        components: { BaseCarousel, MiniProductCard },

        props: {
            products: {
                type: Array,
                default: () => ([]),
            },

            makeMeVeggieUrl: {
                type: String,
                default: '',
            },
        },

        computed: {
            /**
             * Get breakpoints for products carousel.
             *
             * @returns {object}
             */
            breakpoints() {
                return {
                    0: {
                        slidesPerView: 2,
                    },
                    576: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 3.5,
                    },
                    992: {
                        slidesPerView: 2.5,
                    },
                    1377: {
                        slidesPerView: 2.6,
                    },
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    .heading-container {
        text-align: center;
        margin-bottom: 20px;

        @include media-breakpoint-up(lg) {
            text-align: left;
        }
    }

    .products-container {
        @include media-breakpoint-up(lg) {
            position: relative;
        }
    }

    .products-carousel {
        @include media-breakpoint-up(lg) {
            max-width: 85%;
        }

        @include media-breakpoint-up(xl) {
            max-width: 80%;
        }
    }

    ::v-deep .swiper-slide {
        height: auto;
    }

    .link-container {
        text-align: center;
        padding-top: 20px;

        @include media-breakpoint-up(lg) {
            position: absolute;
            top: 70px;
            right: -35px;
            transform: rotate(-90deg);
        }

        @include media-breakpoint-up(xl) {
            right: 0;
        }
    }

    .link {
        font-size: rem(20px);
        font-weight: bold;
        color: primary-palette(2);

        &:hover {
            text-decoration: none;
            color: primary-palette(1);
        }
    }

    ::v-deep .swiper-slide {
        display: flex;
        justify-content: center;
    }
</style>
